<template>
  <blog-conversation-page :shopify-data="parsedShopifyData" />
</template>

<script>
import BlogConversationPage from './BlogConversationPage.vue';

export default {
  name: 'RenderBlogConversationPage',
  components: {
    BlogConversationPage,
  },
  props: {
    shopifyData: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedShopifyData() {
      try {
        return typeof this.shopifyData === 'string'
          ? JSON.parse(this.shopifyData)
          : this.shopifyData;
      } catch (e) {
        console.error('Error parsing shopifyData:', e);
        return {};
      }
    },
  },
};
</script>
